import { ISelectData } from 'components/atoms/SelectComponent';

import { EVotetp } from 'enums/akcionarKorpAkce/votetp';

export const votetpData: ISelectData[] = [
    {
        labelcz: 'ADVI',
        value: EVotetp.ADVI
    },
    {
        labelcz: 'BNDG',
        value: EVotetp.BNDG
    }
];
